import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField, Typography } from "@material-ui/core";
import "./TicketDialog.css";
import { Formatter, isNullOrUndefined } from "./Util";

export class TicketDialog extends Component {
	constructor(props) {
		super(props);
		this.getData();
		this.state = {
			TicketData: [],
			open: false,
			printing: false,
		};

		this.onClose = this.onClose.bind(this);
		this.print = this.print.bind(this);
		this.delete = this.delete.bind(this);
		this.openImage = this.openImage.bind(this);
	}

	print() {
		var callPrint = !this.state.printing;
		this.setState({ printing: callPrint });
		if (callPrint) {
			setTimeout(function () {
				window.print();
			}, 1000);
			setTimeout(this.print, 1200);
		}
	}

	async delete() {
		if (!window.confirm("Are you sure you want to delete?")) return;
		const data = await fetch("Ticket/DeleteTicket", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ticketsId: this.props.TicketsID }),
		});
		this.onClose();
	}

	componentDidUpdate(prevProps) {
		if (this.props.TicketsID !== prevProps.TicketsID) {
			this.getData();
		}
	}
	async getData() {
		var res = [];
		if (this.props.TicketsID) {
			const data = await fetch("Ticket/GetTicketData", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ ticketsId: this.props.TicketsID }),
			});
			res = await data.json();
			console.log(res);
			this.setState({ TicketData: res, open: true });
		}
	}

	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	openImage(x) {
		var newTab = window.open();
		newTab.document.body.innerHTML = '<img src="' + x + '" style="max-width:100%; max-height:100%; height:"auto"; width:"auto";>';
		// w.document.write(image.outerHTML);
	}

	render() {
		var baseData = this.state.TicketData[0] || {};
		var inputProps = { readOnly: true };

		var additionalProps = {};
		if (this.state.printing) {
			additionalProps.fullScreen = true;
		}

		const pics = (this.state.TicketData || []).filter((x) => !isNullOrUndefined(x.picture)).map((x) => x.picture);

		return (
			<Dialog open={this.state.open} onClose={this.onClose} fullWidth={true} {...additionalProps} className="ticket-print" maxWidth="md">
				<DialogTitle>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}>
						<img style={{ width: "40%" }} src="../img/logo.png" alt="Dynamic Logo"></img>
						<div>{baseData.building_name + " - Ticket #" + baseData.ticket_number}</div>
					</div>
				</DialogTitle>
				<DialogContent>
					<TextField variant="outlined" label="Ticket Date" className="ticket-control" value={Formatter(baseData.date_entered, "D")} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Elevator" className="ticket-control" value={baseData.serial_number} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Elevator Type" className="ticket-control" value={baseData.elevator_type} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Ticket Type" className="ticket-control" value={this.state.TicketData.map((item) => item.ticket_type).join(",")} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Mechanic" className="ticket-control" value={baseData.mechanic} InputProps={inputProps}></TextField>
					{this.state.TicketData.map((item) => item.ticket_type)
						.join(",")
						.includes("Maint") && (
						<div
							style={{
								marginTop: "4px",
								display: "inline-block",
							}}>
							<TextField variant="outlined" label="Emergency Light Working?" className="ticket-control" value={Formatter(baseData.emergency_light, "L")} InputProps={inputProps}></TextField>
							<TextField variant="outlined" label="Emergency Phone Working?" className="ticket-control" value={Formatter(baseData.emergency_phone, "L")} InputProps={inputProps}></TextField>
							<TextField variant="outlined" label="Alarm Working?" className="ticket-control" value={Formatter(baseData.alarm, "L")} InputProps={inputProps}></TextField>
						</div>
					)}
					<TextField variant="outlined" label="Work Performed" fullWidth value={baseData.work_performed} multiline style={{ marginTop: "12px" }} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Recommendations" fullWidth value={baseData.recommendation} multiline style={{ marginTop: "12px" }} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Work Completed?" className="ticket-control" value={Formatter(baseData.work_completed, "L")} InputProps={inputProps}></TextField>
					<TextField variant="outlined" label="Signed By" className="ticket-control" value={baseData.signature_name} InputProps={inputProps}></TextField>
					{baseData.signature && (
						<div>
							<Typography variant="caption" display="block" gutterBottom>
								Signature
							</Typography>
							<img src={baseData.signature} alt="No signature uploaded" style={{ height: "150px" }}></img>
						</div>
					)}
					{pics.length > 0 && (
						<div>
							<Typography variant="subtitle2" display="block" gutterBottom>
								Pictures
							</Typography>
							{pics.map((x) => {
								return (
									<img
										style={{
											maxHeight: "80px",
											maxWidth: "80px",
											height: "auto",
											width: "auto",
											cursor: "pointer",
										}}
										onClick={() => {
											this.openImage("data:image/png;base64," + x);
										}}
										src={"data:image/png;base64," + x}
									/>
								);
							})}
						</div>
					)}
					<div
						style={{
							lineHeight: 1,
							pageBreakInside: "avoid",
							pageBreakBefore: "always",
							marginTop: "20px",
						}}>
						<h2 style={{ textAlign: "center" }}>Legal</h2>
						<p style={{ textAlign: "justify" }}>
							<b>Dynamic Elevator Control Corp.</b> assumes no responsibility for any part of the elevator equipment except the upon which work has been done under this contract. No work service examination or liability on our part other than that specifically mentioned herein is included or intended. It is agreed that <b>Dynamic Elevator Control Corp.</b> does not assume possession or control of any part of the equipment and that such remains yours exclusively as the owner lessor, lessee or manager thereof.
						</p>
						<p style={{ textAlign: "justify" }}>
							<b>Dynamic Elevator Control Corp.</b> shall not be held responsible for any loss, damage, injury, delay or detention of persons or property caused by acts of government, civil or military authorities, war, civil commotion, theft, vandalism, labor troubles, explosion, fire, power failure, water damage, storms, lighting, natural or public catastrophe, acts of god, or by any other cause which is unavailable or beyond our reasonable control, and, in any event, we shall not be liable for consequential damages. It is agreed that in consideration of the services enumerated
							herein that nothing in this agreement shall be construed to mean that <b>Dynamic Elevator Control Corp.</b> or its representatives assumes any liability whatsoever on account of accidents, injuries, delay or detention to persons or property. The purchaser shall remain solely liable for any and all actions or claims for damages to persons property while riding on, being in or about the elevator or the associated areas regardless of whether such actions result from the use, operation, maintenance or condition of the elevator, machine rooms, hatchway or any of their
							components parts and the Purchaser does hereby further unconditionally agree to indemnify and hold harmless <b>Dynamic Elevator Control Corp.</b> and its officers, directors and employees from any and all claims as enumerated above, including, but not limited to any demands, judgments, awards liabilities, costs, attorney's fees or any other damages on account of any such actions or claims regardless of the cause of said actions and regardless of any negligence upon the part of <b>Dynamic Elevator Control Corp.</b>
						</p>
						<p style={{ textAlign: "justify" }}>
							Purchaser shall shut down the equipment immediately upon manifestation of any irregularities in operation or appearance in the equipment, notify <b>Dynamic Elevator Control Corp.</b> at once and keep equipment shut down until the completion of the repairs and further the Purchase shall keep the equipment under continued surveillance by competent personal to detect such irregularities. The Purchaser shall give <b>Dynamic Elevator Control Corp.</b> notice within ten days after occurrence of any accident in or about the elevator.{" "}
						</p>
						<p style={{ textAlign: "justify" }}>Purchaser agrees to pay for work performed upon presentation of invoice. </p>
						<p style={{ textAlign: "justify" }}>
							Nonpayment of any sum under this agreement shall be considered a material breach thereof. In the event of a breach of this agreement or the failure to pay any sum due under this agreement within thirty (30) days from the billing date. <b>Dynamic Elevator Control Corp.</b> may, at its option, declare all sums due or to become due under this agreement due payable in full as and for agreed and liquidate damages, and not as a penalty, and until the same are paid. <b>Dynamic Elevator Control Corp.</b> shall be discharged and released from any obligation and/or liability
							under the terms of this agreement.
						</p>
						<p style={{ textAlign: "justify" }}>
							In the event any attorney is engaged to enforce construe or defend any of the terms and conditions of this agreement or to collect any payment or lost profits due here under either with or without suit, the Purchaser agrees to pay all attorney's fees and costs incurred by <b>Dynamic Elevator Control Corp.</b>{" "}
						</p>
						<p style={{ textAlign: "justify" }}>
							The Purchaser does hereby waive trial by jury and does further hereby consent to the venue of any proceeding or lawsuit under this agreement to be in the County of Broward and State of Florida other county of <b>Dynamic Elevator Control Corp.</b> choice.{" "}
						</p>
						<p style={{ textAlign: "justify" }}>No agent or employee shall have the authority to waive or modify any of the above terms of this agreement.</p>
					</div>
				</DialogContent>
				<DialogActions className="hidden-print">
					<Button onClick={this.print} color="primary">
						Print
					</Button>
					{!this.props.IsClientPortal && (
						<Button onClick={this.delete} color="primary">
							Delete
						</Button>
					)}
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
